/**
 * Created by andrey on 01.03.2021.
 */

const UnitsSyncer = function (slotId) {
    this.slotId = slotId;
    this.isFake = this.slotId === undefined;

    this.data = new Map();

    if (this.isFake) {
        return;
    }

    const adapterCode = this.getAdapterCode();

    connector.synchronizer.addAdapter(adapterCode, {
        getInfo: () => {
            if (!connector.synchronizer.usesRestTransport()) {
                return "";
            }

            return { syncout: true, ...this.getInfo() };
        },

        updateInfo: (serverData) => this.updateInfo(serverData),

        // client syncer sends units per family (units_wood_0, etc.), reassemble into units0 for updateInfo
        beforeUpdate: (snapshot) => {
            const stored = snapshot[adapterCode];

            const families = Object.keys(snapshot)
                .filter((key) => key.startsWith("units_"))
                .filter((key) => (this.slotId ? key.endsWith(`_${this.slotId}`) : !/_\d$/.test(key)))
                .reduce((units, key) => {
                    const familyCode = key.slice("units_".length, this.slotId ? -(this.slotId.length + 1) : undefined);
                    units[familyCode] = snapshot[key];
                    return units;
                }, {});

            const storedFamilies = typeof stored === "object" ? stored : undefined;

            snapshot[adapterCode] = { ...storedFamilies, ...families };
            delete snapshot[adapterCode].syncout;

            if (stored && (stored !== storedFamilies || stored.syncout)) {
                connector.synchronizer.addSendTask(adapterCode);
            }
        }
    });

    this.initFamily("intact");

    Object.values(Meta.GetAvailableLocations()).forEach((location) => {
        if (location.locationType === "merge" && location.slotId === this.slotId) {
            Object.keys(Families.listExpeditionCodes(location.id)).forEach((code) => this.initFamily(code));
        }
    });

    if (cleverapps.config.type === "merge") {
        this.merge3saver = new UnitSaver(this.slotId);
        this.merge3saver.loadAll().forEach((info) => {
            const code = info.data.code;
            const x = info.x;
            const y = info.y;

            this.initFamily(code);

            if (this.data.has(code)) {
                this.data.get(code)[this.getPositionKey(x, y)] = this.getFormat(code).encodeUnit(info.data, x, y, code);
            }
        });
    } else {
        const prefix = this.getSaverKey("");
        cleverapps.dataLoader.listExistingKeys(prefix).forEach((storageKey) => {
            const code = storageKey.replace(prefix, "");

            this.initFamily(code);

            if (this.data.has(code)) {
                this.data.set(code, this.getFormat(code).decodeFamily(cleverapps.dataLoader.load(this.getSaverKey(code)), code));
            }
        });
    }
};

UnitsSyncer.prototype.getSaverKey = function (code) {
    return `${cleverapps.config.name + connector.platform.getLocalStoragePrefix()}_units${this.slotId}_${code}`;
};

UnitsSyncer.prototype.getAdapterCode = function () {
    return `units${this.slotId}`;
};

UnitsSyncer.prototype.getSyncerCode = function (code) {
    return `units_${code}${this.slotId ? `_${this.slotId}` : ""}`;
};

UnitsSyncer.prototype.getPositionKey = function (x, y) {
    return `${x}_${y}`;
};

UnitsSyncer.prototype.parsePositionKey = function (key) {
    const parts = key.split("_");
    return {
        x: parseInt(parts[0]),
        y: parseInt(parts[1])
    };
};

UnitsSyncer.prototype.getFormat = function (code) {
    return code === "intact" ? UnitsSyncerFormat.INTACT : UnitsSyncerFormat.REGULAR;
};

UnitsSyncer.prototype.restoreDeletedStage = function (data, code) {
    const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
    if (!deleted || !deleted.length) {
        return;
    }

    for (let i = 0; i < deleted.length && deleted[i] <= data.stage; i++) {
        data.stage += 1;
    }
};

UnitsSyncer.prototype.removeDeletedStage = function (data, code) {
    const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
    if (!deleted || !deleted.length) {
        return;
    }

    const original = data.stage;
    for (let i = 0; i < deleted.length && deleted[i] <= original; i++) {
        data.stage -= 1;
    }
};

UnitsSyncer.prototype.initFamily = function (code) {
    if (code === "unknown" || Unit.DISABLED_CODES[code] || Unit.DELETED_CODES[code]) {
        return;
    }

    if (this.data.has(code)) {
        return;
    }

    this.data.set(code, {});

    connector.synchronizer.addAdapter(this.getSyncerCode(code), {
        getInfo: () => this.getFormat(code).encodeFamily(this.data.get(code), code)
    });
};

UnitsSyncer.prototype.listAllUnits = function (fromSync) {
    const units = [];

    this.data.forEach((familyData, code) => {
        Object.keys(familyData).forEach((positionKey) => {
            const info = this.parsePositionKey(positionKey);
            info.data = this.getFormat(code).decodeUnit(familyData[positionKey], code);

            if (!fromSync) {
                this.removeDeletedStage(info.data, code);
            }

            units.push(info);
        });
    });
    return units;
};

UnitsSyncer.prototype.reset = function () {
    if (this.isFake) {
        return;
    }

    this.data.forEach((familyData, code) => {
        this.data.set(code, {});
        connector.synchronizer.addSendTask(this.getSyncerCode(code));
    });

    if (connector.synchronizer.usesRestTransport()) {
        connector.synchronizer.addSendTask(this.getAdapterCode());
    }

    if (this.merge3saver) {
        this.merge3saver.reset();
    } else {
        this.data.forEach((familyData, code) => {
            cleverapps.dataLoader.remove(this.getSaverKey(code));
        });
    }
};

UnitsSyncer.prototype.remove = function (x, y, code) {
    if (this.isFake) {
        return;
    }

    const familyData = this.data.get(code);
    if (!familyData) {
        return;
    }

    const key = this.getPositionKey(x, y);
    if (!familyData[key]) {
        return;
    }

    delete familyData[key];
    connector.synchronizer.addSendTask(this.getSyncerCode(code));

    if (this.merge3saver) {
        this.merge3saver.remove(x, y);
    } else {
        const data = this.getFormat(code).encodeFamily(familyData, code);
        if (data.length) {
            cleverapps.dataLoader.save(this.getSaverKey(code), data);
        } else {
            cleverapps.dataLoader.remove(this.getSaverKey(code));
        }
    }
};

UnitsSyncer.prototype.save = function (x, y, data) {
    if (this.isFake) {
        return;
    }

    const code = data.code;

    let familyData = this.data.get(code);
    if (!familyData) {
        this.initFamily(code);
        familyData = this.data.get(code);
        cleverapps.throwAsync(`init unexpected family ${code}`);
    }
    if (!familyData) {
        return;
    }

    this.restoreDeletedStage(data, code);

    const key = this.getPositionKey(x, y);
    familyData[key] = this.getFormat(code).encodeUnit(data, x, y, code);

    connector.synchronizer.addSendTask(this.getSyncerCode(code));

    if (this.merge3saver) {
        this.merge3saver.save(x, y, data);
    } else {
        cleverapps.dataLoader.save(this.getSaverKey(code), this.getFormat(code).encodeFamily(familyData, code));
    }
};

UnitsSyncer.prototype.getInfo = function () {
    const result = {};

    this.data.forEach((familyData, code) => {
        result[code] = this.getFormat(code).encodeFamily(familyData, code);
    });

    return result;
};

UnitsSyncer.prototype.updateInfo = function (serverData) {
    if (this.isFake) {
        return;
    }

    if (serverData === undefined) {
        return;
    }

    delete serverData.syncout;

    Object.keys(serverData).forEach((code) => this.initFamily(code));

    this.data.forEach((familyData, code) => {
        this.data.set(code, this.getFormat(code).decodeFamily(serverData[code], code));
    });

    if (this.merge3saver) {
        this.merge3saver.updateInfo(this.listAllUnits(true));
    } else {
        this.data.forEach((familyData, code) => {
            cleverapps.dataLoader.save(this.getSaverKey(code), this.getFormat(code).encodeFamily(familyData, code));
        });
    }
};
